import { capitalCase } from 'change-case';
// @mui
import { Box, Container, Tab, Tabs } from '@mui/material';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useSettings from '../../hooks/useSettings';
import useTabs from '../../hooks/useTabs';
// components
import { useMemo } from 'react';
import { Outlet, useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import useAuth from 'src/hooks/useAuth';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import Page from '../../components/Page';
import { navItems } from './navItems';

// ----------------------------------------------------------------------

export default function SettingsLayout() {
  const { themeStretch } = useSettings();
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const ACCOUNT_TABS = useMemo(() => navItems(user?.role), [user?.role]);

  const defaultTab = () => {
    const matchingTab = ACCOUNT_TABS.find((tab) => location.pathname.includes(tab.path));
    return matchingTab?.value || 'profile';
  };

  const { currentTab, onChangeTab } = useTabs(defaultTab());

  return (
    <Page title="Settings">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading="Settings"
          links={[{ name: 'Settings', href: PATH_DASHBOARD.root }]}
        />

        <Tabs
          allowScrollButtonsMobile
          variant="scrollable"
          scrollButtons="auto"
          value={currentTab}
          onChange={onChangeTab}
        >
          {ACCOUNT_TABS.map((tab) => (
            <Tab
              disableRipple
              key={tab.value}
              label={capitalCase(tab.value)}
              icon={tab.icon}
              value={tab.value}
              onClick={() => navigate(tab.path)}
            />
          ))}
        </Tabs>

        <Box sx={{ mb: 5 }} />

        <Outlet />
      </Container>
    </Page>
  );
}
